import QuoteBoxContainer from "./QuoteBoxContainer";
export default QuoteBoxContainer;
